import React, { useEffect, useRef } from 'react'

type InfiniteScrollComponentProps = {
    loading: boolean;
    hasMore: boolean;
    onLoadMore: () => void;
};

export const InfiniteScrollComponent = ({
    loading,
    hasMore,
    onLoadMore,
}:InfiniteScrollComponentProps) => {
    const observerRef = useRef<HTMLDivElement>(null);

    useEffect(() =>{
        if(loading || !hasMore) return;

        const observer = new IntersectionObserver((entries) => {
            if(entries[0].isIntersecting) {
                onLoadMore();
            }
        });
        const currentRef = observerRef.current;
        if(currentRef) observer.observe(currentRef);

        return () => {
            if(currentRef) observer.unobserve(currentRef);
        };

    },[loading, hasMore, onLoadMore]);

    return <div ref={observerRef} style={{ height: 1 }} />;

}